
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

interface FacebookGroup {
  id: string;
  user_id: string;
  platform: string;
  group_id: string;
  group_name: string;
  group_privacy: string;
  can_post: boolean;
  social_account_id: string;
  created_at: string;
  updated_at: string;
}

export const useFacebookGroups = () => {
  const [groups, setGroups] = useState<FacebookGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const fetchGroups = async () => {
    try {
      const { data, error } = await supabase
        .from('facebook_groups')
        .select('*')
        .eq('can_post', true)
        .order('group_name', { ascending: true });

      if (error) throw error;
      setGroups(data || []);
    } catch (error) {
      console.error('Error fetching Facebook groups:', error);
      toast({
        title: "Error",
        description: "Failed to load Facebook groups",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return {
    groups,
    loading,
    refetch: fetchGroups
  };
};
